import React from 'react';
import { useTranslation } from 'react-i18next';
import { Navbar, Nav, OverlayTrigger, Tooltip } from '@isyc-react/design/bootstrap';
import { namespaces } from 'i18n/i18n.constants';
import { PersonSex } from '@isyc-react/types/core';
import { useLogout } from '@isyc-react/auth/modules/pods/logout';
import { useAuthContext } from '@isyc-react/auth/modules/context';
import logo from 'assets/img/logo.png';
export const TopBar = () => {
    const { logout } = useLogout();
    const { user } = useAuthContext();
    const { t } = useTranslation(namespaces.common);
    return (React.createElement(React.Fragment, null,
        React.createElement("header", null,
            React.createElement(Navbar, { className: 'bg-white' },
                React.createElement("div", { className: 'container' },
                    React.createElement(Navbar.Brand, { href: '#' },
                        React.createElement("img", { src: logo, alt: 'logo' })),
                    user && (React.createElement(Nav, { className: 'ms-auto d-flex align-items-center' },
                        user && (React.createElement("div", { className: 'font-size-15' }, user.person && user.person.name ? (React.createElement(React.Fragment, null,
                            user.person.sex === PersonSex.MALE && 'M. ',
                            user.person.sex === PersonSex.FEMALE && 'Ms. ',
                            user.person.name,
                            " ",
                            user.person.surname)) : (React.createElement(React.Fragment, null, user.alias || user.username)))),
                        React.createElement(Nav.Item, { as: 'li' },
                            React.createElement(OverlayTrigger, { delay: { show: 500, hide: 0 }, placement: 'bottom', overlay: React.createElement(Tooltip, { id: 'exit-tooltip' }, t('appTopBarExit')) },
                                React.createElement("button", { type: 'button', className: 'btn border-0', onClick: () => {
                                        logout();
                                    } },
                                    React.createElement("i", { className: 'mdi mdi-power text-primary font-size-20' })))))))))));
};
